<template>
  <svg
    class="custom-icon"
    width="12"
    height="4"
    viewBox="0 0 12 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.799805" width="12" height="2.4" rx="1" />
  </svg>
</template>
